export default __webpack_public_path__ + "51840cba63a5f11d4000c1f5e861831d.png";